import * as XLSX from "xlsx";
import { format } from "date-fns";

export function exportToExcel({dataExcel, totalDoc}){
    console.log(dataExcel);
    console.log(totalDoc);
    
    // const workbook = XLSX.utils.book_new();
    // XLSX.utils.book_append_sheet(workbook, worksheet, "Ventas");

    const data = dataExcel.map(e => ({
        Fecha: format(new Date(e.createdAt), 'dd/MM/yyyy'),
        Documento: e.numDocumento,
        Cliente: e.cliente.nombre,
        DNI_CUIT: e.cliente.cuitCuilDni,
        Ciudad: e.cliente.ciudad,
        Direccion: e.cliente.direccion,
        Zona: e.cliente.zona,
        Telefono: e.cliente.telefono,
        Total_Documento: e.total
    }));

    
    const dataExcels = XLSX.utils.json_to_sheet(data);

    dataExcels["!cols"] = [
        { wch: 12 },
        { wch: 15 },
        { wch: 25 },
        { wch: 15 },  
        { wch: 15 },
        { wch: 30 },
        { wch: 12 },
        { wch: 15 },
        { wch: 18 },
    ];

    const filaFinal = data.length + 3;
    dataExcels[`H${filaFinal}`] = { t: "s", v: "TOTAL VENTAS:" };
    dataExcels[`I${filaFinal}`] = { t: "n", v: totalDoc };

    const rango = XLSX.utils.decode_range(dataExcels["!ref"]);
    rango.e.r = filaFinal - 1;
    dataExcels["!ref"] = XLSX.utils.encode_range(rango);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, dataExcels, "Ventas");    
    XLSX.writeFile(workbook, "Ventas.xlsx");
    
};
